/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// @material-ui/core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// @material-ui icons
// core components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";

export default function CardExampleListGroupsHeader() {
  return (
    <Card style={{ width: "20rem" }}>
      <CardHeader color="danger">Featured</CardHeader>
      <List component="nav">
        <ListItem>
          <ListItemText primary="Cras justo odio" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Dapibus ac facilisis in" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Vestibulum at eros" />
        </ListItem>
      </List>
    </Card>
  );
}
